import Vue from "vue";
import VeeValidate from "vee-validate";
import postalCodesJs from "postal-codes-js";

Vue.use(VeeValidate);

const dict = {
  attributes: {
    email: "Email Address",
    password: "Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password"
  },
  messages: {
    required: fieldName => `The ${fieldName} is required`,
    email: "Please enter a valid email address",
    min: (fieldName, params) =>
      `The ${fieldName} must have at least ${params[0]} characters`,
    confirmed: (fieldName, params) =>
      `The ${fieldName} does not match the ${params[0]}`
  },
  custom: {
    agreement: {
      required: "You have to agree to our Terms of Service and Privacy Policy"
    },
    newPassword: {
      regex: fieldName =>
        `The ${fieldName} must contain lower and upper case letters, a number and a special character`
    }
  }
};
VeeValidate.Validator.localize("en", dict);

const isPostalCode = (value, { country } = {}) => {
  const rsp = postalCodesJs.validate(country, value);
  console.log(rsp);

  return typeof rsp === "boolean" ? rsp : false;
};
const paramNames = ["country"];
VeeValidate.Validator.extend("postalCode", isPostalCode, {
  paramNames
});
